import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArnicaLogoDk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 180,
	height: 64,
	viewBox: "0 0 180 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1782_1662)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1782_1662",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 180,
			height: 64,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M180 0.888672H0V63.1109H180V0.888672Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1782_1662)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask1_1782_1662",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 180,
				height: 64,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M179.253 0.888672H0V63.3463H179.253V0.888672Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask1_1782_1662)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M25.3403 63.3817H0.194336V0.820801H25.3403V6.82227H6.21066V57.3802H25.3403V63.3817Z",
						fill: "#44BDA4"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M179.214 63.3817H154.071V57.3802H173.198V6.82227H154.071V0.820801H179.214V63.3817Z",
						fill: "#44BDA4"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M44.5252 44.7217H37.2718V42.1077H37.1859C35.9615 44.4598 32.9469 45.5503 30.1067 45.5503C22.4166 45.5503 17.9175 39.5363 17.9175 32.6054C17.9175 24.6749 23.6409 19.7061 30.1067 19.7061C34.0806 19.7061 36.3099 21.625 37.1859 23.1059H37.2718V20.5345H44.5252V44.7217ZM31.1999 38.7958C35.7418 38.7958 37.2718 34.9603 37.2718 32.6054C37.2718 29.6867 35.2622 26.4605 31.1544 26.4605C27.0469 26.4605 25.1709 29.9461 25.1709 32.6936C25.1709 34.9603 26.8321 38.7958 31.1999 38.7958Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M49.7715 20.5345H56.5881V23.1059H56.6764C57.2875 21.9297 58.5548 19.7061 62.7482 19.7061V26.9843C59.3829 27.07 57.0248 27.7676 57.0248 31.4294V44.7217H49.7715V20.5345Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M66.5938 20.5345H73.365V23.1059H73.4532C74.1955 21.9297 75.7255 19.7061 80.0503 19.7061C82.368 19.7061 84.9456 20.6655 86.256 21.7989C87.5662 22.9322 89.0533 24.8511 89.0533 29.5985V44.7217H81.7998V31.5174C81.7998 29.8175 81.7998 26.5059 77.9977 26.5059C73.847 26.5059 73.847 30.0796 73.847 31.5578V44.7217H66.5938V20.5345Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M101.464 17.9639H94.2134V12.4736H101.464V17.9639ZM101.464 44.7223H94.2134V20.5351H101.464V44.7223Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M131.216 35.5271C129.905 41.0172 125.055 45.5052 118.504 45.5052C111.162 45.5052 105.527 39.753 105.527 32.5628C105.527 25.3726 111.076 19.7036 118.327 19.7036C124.75 19.7036 129.948 23.9321 131.17 29.8579H123.831C123.043 28.2009 121.602 26.4581 118.587 26.4581C115.136 26.2842 112.821 29.1177 112.821 32.6032C112.821 36.0887 115.138 38.7481 118.587 38.7481C121.602 38.7481 123.043 37.0053 123.831 35.5246H131.213L131.216 35.5271Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M160.669 44.7217H153.415V42.1077H153.329C152.107 44.4598 149.091 45.5503 146.253 45.5503C138.562 45.5503 134.061 39.5363 134.061 32.6054C134.061 24.6749 139.785 19.7061 146.253 19.7061C150.227 19.7061 152.453 21.625 153.329 23.1059H153.415V20.5345H160.669V44.7217ZM147.343 38.7958C151.888 38.7958 153.415 34.9603 153.415 32.6054C153.415 29.6867 151.406 26.4605 147.298 26.4605C143.19 26.4605 141.314 29.9461 141.314 32.6936C141.314 34.9603 142.973 38.7958 147.341 38.7958H147.343Z",
						fill: "white"
					})
				]
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1782_1662",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 180,
			height: 64,
			fill: "white"
		})
	}) })]
});
export default SvgArnicaLogoDk;
